export enum TableColumnType {
    Text = 0,
    Number = 1,
    Money = 2,
    Date = 3,
    Time = 4,
    DateTime = 5,
    DateTime2 = 6,
    Guid = 7,
    Bool = 8,
    DayOfMonth = 9,
    Array = 10,
    HTML = 11,
    None = 12,
    Image = 13
}

/* reverse engineered default values

    flex: number = -1
    hidable: boolean = false
    hidden: boolean = false
    hidingToggleText: string = null
    maxWidth:  -1
    minWidth: 10
    name: string = "purchasePrice"
    readonly: boolean = false
    renderer: function = undefined (cell: any) => {}
    resizable: boolean = false
    sortable: boolean = true
    width: number = 100
*/

export class TableColumn {
    type: TableColumnType;
    width: number;
    sortable: boolean;
    flex: number;
    caption: string;
    name: string;
    hidden: boolean;
    gridColumn: any;

    columnClass: string = null;

    getValueFunction: Function;
    formatFunction: Function;
    callbackFunction: Function;

    columnClassFunction: Function;

    constructor(
        type: TableColumnType = TableColumnType.Text,
        name = '',
        caption = '',
        width = -1,
        sortable = true,
        flex = -1,
        hidden = false,
        getValueFunction: (val) => any = null,
        formatFunction: (val) => any = null,
        callbackFunction: (val) => any = null,
        ) {
        this.type = type;
        this.width = width;
        this.sortable = sortable;
        this.flex = flex;
        this.caption = caption;
        this.name = name;
        this.hidden = hidden;
        this.getValueFunction = getValueFunction;
        this.formatFunction = formatFunction;
        this.callbackFunction = callbackFunction;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/table-column.ts